module.exports = __webpack_public_path__ + "img/chart-1.cf82922b.jpg";